const DEFAULT_MAX_DIMENSION = 2048;

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Unable to read the selected image.'));
    image.src = src;
  });
}

export async function resizeImageFile(
  file: File,
  maxDimension = DEFAULT_MAX_DIMENSION,
): Promise<Blob> {
  if (!file.type.startsWith('image/')) {
    return file;
  }

  const objectUrl = URL.createObjectURL(file);

  try {
    const image = await loadImage(objectUrl);
    const largestDimension = Math.max(image.naturalWidth, image.naturalHeight);

    if (largestDimension <= maxDimension) {
      return file;
    }

    const scale = maxDimension / largestDimension;
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(image.naturalWidth * scale);
    canvas.height = Math.round(image.naturalHeight * scale);

    const context = canvas.getContext('2d');

    if (!context) {
      throw new Error('Unable to resize the selected image.');
    }

    context.drawImage(image, 0, 0, canvas.width, canvas.height);

    return await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(blob);
            return;
          }

          reject(new Error('Unable to resize the selected image.'));
        },
        file.type === 'image/png' ? 'image/png' : 'image/jpeg',
        0.92,
      );
    });
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
